import { render } from "./IconArchive.vue?vue&type=template&id=3f74e198"
import script from "./IconArchive.vue?vue&type=script&lang=ts"
export * from "./IconArchive.vue?vue&type=script&lang=ts"
script.render = render

export default script